import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    if (typeof window === 'undefined') return 72;
    const saved = sessionStorage.getItem('chikung-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 94);
    }
    return 72;
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem('chikung-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 94) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 94);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-brand-purpleDark text-brand-surface border-b border-brand-gold/40" data-id="element-254" data-mp="2gemtq6q8v1p7">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-255" data-mp="2cd191z7gxj4g">
        <div className="md:hidden overflow-hidden relative" data-id="element-256" data-mp="150r4u69jfeks">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 20,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-257" data-mp="14y500ee17d69">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-258" data-mp="17e4o3nzlnb8b">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-259" data-mp="sgu6dwwd5945">
                  <ClockIcon className="w-3.5 h-3.5 shrink-0" data-id="element-260" data-mp="xfp03tvvci31" />
                  <span data-id="element-261" data-mp="jplhdcw776ic">El precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-1.5 py-0.5 ml-0.5 text-white" data-id="element-262" data-mp="jo0n7odsppl0">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-263" data-mp="epfipcrigjqr" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-264" data-mp="pxtiwaaz4gv">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-265" data-mp="sts8mtz5x6d" />
                  <span data-id="element-266" data-mp="4tvs95vpud9e">
                    <strong className="tabular-nums text-brand-goldLight" data-id="element-267" data-mp="3i8vc80pcazjx">
                      {spotsTaken}%
                    </strong>{' '}
                    de los cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-268" data-mp="3ramdmtcukk7z" />
                <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-2.5 py-0.5 rounded-sm text-[10px] shrink-0" data-id="element-269" data-mp="3magqnqhivlw8">
                  Ver el pack
                </a>
              </div>)}
          </motion.div>
        </div>

        <div className="hidden md:flex items-center justify-center gap-6 text-xs font-medium" data-id="element-270" data-mp="9sth9pj8mapk">
          <div className="flex items-center gap-2 whitespace-nowrap text-brand-goldLight uppercase tracking-wider" data-id="element-271" data-mp="nsl0q5siwjay">
            <ClockIcon className="w-4 h-4 shrink-0" data-id="element-272" data-mp="iv2p27n4fpz9" />
            <span data-id="element-273" data-mp="is6sonqx99cx">El precio de lanzamiento cierra en</span>
            <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-2 py-0.5 text-white normal-case" data-id="element-274" data-mp="12vckyudj3ipl">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="w-px h-4 bg-brand-goldLight/30 shrink-0" data-id="element-275" data-mp="1bqsfldm3y1w8" />
          <div className="flex items-center gap-2 whitespace-nowrap" data-id="element-276" data-mp="1gn0vit84pz4g">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-277" data-mp="jybhjdzmhqnr" />
            <span className="text-brand-surface/85" data-id="element-278" data-mp="ny3h5171gmgz">
              <strong className="tabular-nums text-brand-goldLight" data-id="element-279" data-mp="o0y3iy9m4hd1">
                {spotsTaken}%
              </strong>{' '}
              de los cupos tomados
            </span>
          </div>
          <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-3 py-1 rounded-sm text-[10px] hover:bg-brand-goldLight hover:text-brand-purpleDark transition-colors duration-150 ease-out shrink-0" data-id="element-280" data-mp="xuydbdfuaas3">
            Ver el pack
          </a>
        </div>
      </div>
    </div>;
}